import { AxiosResponse } from 'axios';
import qs from 'qs';
import { Res, ResStatus } from './api.types';

export const repeatArraySerializer = (params: any) =>
  qs.stringify(params, { arrayFormat: 'repeat' });

export const isSuccessful = <R>(res: AxiosResponse<Res<R>, any>) =>
  res.data.status === ResStatus.OK;
